Valeurs = {

	init : ->
		console.log "Valeurs init"

		if not Config.isMobile()
			@hoverManager()
			@overlayManager()
		else
			@accordeonManager()

	hoverManager : ->

		$('.block-valeurs .valeur').on "mouseenter", (ev) ->
			$elt = $(@)
			$main = $elt.find('.valeur--main')
			if $elt.find('.valeur--hover').length
				$hover = $elt.find('.valeur--hover')
				tlShowHover = new TimelineLite
				tlShowHover.addLabel('start')
					.fromTo($main, 0.3, {y:'-50%', autoAlpha:1}, {y:'-70%', autoAlpha:0, ease:Back.easeInOut}, 'start')
					.fromTo($hover, 0.4, {y:'-30%', autoAlpha:0}, {y:'-50%', autoAlpha:1, ease:Back.easeInOut}, 'start')
			else
				$main.addClass('hover')

			$(@).one "mouseout", (ev) ->
				$elt = $(@)
				
				if $elt.find('.valeur--hover').length
					$hover = $elt.find('.valeur--hover')
					tlHideHover = new TimelineLite
					tlHideHover.addLabel('start')
						.fromTo($hover, 0.3, {y:'-50%', autoAlpha:1}, {y:'-70%', autoAlpha:0, ease:Back.easeInOut}, 'start')
						.fromTo($main, 0.4, {y:'-30%', autoAlpha:0}, {y:'-50%', autoAlpha:1, ease:Back.easeInOut}, 'start')
				else
					$main.removeClass('hover')

	overlayManager : ->

		overlay = $('.valeurs--overlay')

		$('.block-valeurs .valeur').on "click", (ev) ->
			# Get slide ID
			slideId = $(@).attr('data-slide')
			
			# Show Overlay
			tlShowOverlay = new TimelineLite
			tlShowOverlay.addLabel('start')
				.add ->	
					videoIndex = $('.slider-video').find('#slide-video-'+slideId).index() - 1
					txtIndex = $('.slider-txt').find('#slide-txt-'+slideId).index() - 1

					$('.slider-video').slick('slickGoTo', videoIndex, false)
					$('.slider-txt').slick('slickGoTo', txtIndex, false)
				.fromTo overlay.find('.slider-video-container'), 1, {y:'-105%'}, {y:'0%', ease:Expo.easeInOut}, 'start'
				.fromTo overlay.find('.slider-txt'), 1, {y:'105%'}, {y:'0%', ease:Expo.easeInOut}, 'start'
				.fromTo overlay.find('.cta_close'), 0.3, {autoAlpha:0, y:20}, {y: 0, autoAlpha:1, ease:Quad.easeOut}
				.fromTo overlay.find('.control'), 0.3, {autoAlpha:0, y:-20}, {y: 0, autoAlpha:1, ease:Quad.easeOut}

		$('.valeurs--overlay .cta_close').on "click", (ev) ->
			# Hide overlay
			tlHideOverlay = new TimelineLite
			tlHideOverlay.addLabel('start')
				.fromTo overlay.find('.cta_close'), 0.3, {autoAlpha:1, y:0}, {y: -20, autoAlpha:0, ease:Quad.easeOut}, 'start'
				.fromTo overlay.find('.control'), 0.3, {autoAlpha:1, y:0}, {y: 20, autoAlpha:0, ease:Quad.easeOut}, 'start'
				.addLabel('hide')
				.fromTo overlay.find('.slider-video-container'), 1, {y:'0%'}, {y:'105%', ease:Expo.easeInOut}, 'hide'
				.fromTo overlay.find('.slider-txt'), 1, {y:'0%'}, {y:'-105%', ease:Expo.easeInOut}, 'hide'
				.add ->
					$('.valeurs--overlay .video--embed iframe').remove()
				

		$('.valeurs--overlay .control').on "click", (ev) ->
			if $(@).hasClass('control_next')
				$.each $('.valeurs--overlay [slick]'), (i, slider) ->
					if $(slider).hasClass('slider-video')
						$(slider).slick('slickNext')
					else
						$(slider).slick('slickPrev')

	accordeonManager : ->
		$('.block-valeurs .valeur--header').on "click", (ev) ->

			$parent = $(@).parents('.valeur')			
			$content = $parent.find(".valeur--mobile");

			if not $parent.hasClass("closed")
				TweenLite.to($content, 0.6, {height:0, ease:Quint.easeInOut})
				$parent.addClass("closed")
			else
				TweenLite.set($content, {height:"auto"})
				TweenLite.from($content, 0.6, {height:0, ease:Quint.easeInOut})
				$parent.removeClass("closed");


	destroy : ->
		console.log "Valeurs destroy"
}